import { createContext, useContext, type ReactNode } from 'react';
import type { EditRequest } from './types';

export interface EditActionTransport {
  openEditActionStream(
    runId: string,
    req: EditRequest,
    blockContent: string,
  ): Promise<ReadableStream<Uint8Array>>;
}

export const EditActionTransportContext = createContext<EditActionTransport | null>(null);

export function EditActionTransportProvider({
  transport,
  children,
}: {
  transport: EditActionTransport;
  children: ReactNode;
}) {
  return (
    <EditActionTransportContext.Provider value={transport}>
      {children}
    </EditActionTransportContext.Provider>
  );
}

export function useEditActionTransport(): EditActionTransport | null {
  return useContext(EditActionTransportContext);
}
